import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e27ad4e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=1e27ad4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e27ad4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e27ad4e')) {
      api.createRecord('1e27ad4e', component.options)
    } else {
      api.reload('1e27ad4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1e27ad4e&scoped=true", function () {
      api.rerender('1e27ad4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/supersubsidy/marketingEvents/index.vue"
export default component.exports